import React, { useState, useEffect } from "react";
import { getPosts, getHomePageText } from "../contentful";
import PostItem from "../components/PostItem/PostItem";
import SearchBar from "../components/SearchBar/SearchBar";
import marked from "marked";
import YearHeader from "../components/YearHeader/YearHeader";

const Home = () => {
  const [posts, setPosts] = useState([]);
  const [displayPosts, setDisplayPosts] = useState([]);
  const [intro, setIntro] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    getPosts().then((data) => {
      setPosts(data.filter((p) => p.fields.homepage));
      setDisplayPosts(data.filter((p) => p.fields.homepage));
    });
    getHomePageText().then((data) => setIntro(data[0].fields.text));
  }, []);

  const yearsArray = [
    ...new Set(posts.map((c) => new Date(c.fields.date).getFullYear())),
  ];

  const filterPosts = (e) => {
    const term = e.target.value;
    if (term === "") {
      setDisplayPosts(posts);
    } else {
      setDisplayPosts(
        posts.filter((c) => {
          return (
            c.fields.title?.toLowerCase().includes(term.toLowerCase()) ||
            c.fields.body?.toLowerCase().includes(term.toLowerCase())
          );
        })
      );
    }
  };

  return (
    <div className='page-contents'>
      {intro && (
        <div className='white-panel'>
          <section dangerouslySetInnerHTML={{ __html: marked(intro) }} />
        </div>
      )}
      <SearchBar
        title='Search posts'
        placeholder='Type to search titles and content'
        filterItems={filterPosts}
      />
      {yearsArray.map((y) => {
        const postsToShow = displayPosts.filter(
          (p) => new Date(p.fields.date).getFullYear() === y
        );

        if (postsToShow.length === 0) return null;
        return (
          <div>
            <YearHeader year={y} />
            <div className='homepage-posts-container'>
              {postsToShow.map((post) => (
                <PostItem key={post.sys.id} post={post.fields} />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Home;
